import { FC, KeyboardEvent } from 'react';
import { Paper, Modal, Grid, Button } from '@material-ui/core';
import { useStyles } from './styles';
import { observer } from 'mobx-react-lite';
import { ConfirmActionDialogProps } from 'components/Dialogs';
const UserKeyDelete: FC<ConfirmActionDialogProps> = observer(
  ({ label, buttonLabel, action, openModal, handleClose }) => {
    const classes = useStyles();
    const handelAction = () => {
      if (action) {
        action();
      }
      handleClose();
    };
    const handleKeyPressed = (event: KeyboardEvent<HTMLDivElement>) => {
      if (event.code === 'Enter') {
        handelAction();
      }
    };
    return (
      <>
        <Modal
          className={classes.modal}
          disablePortal
          onEscapeKeyDown={handleClose}
          onKeyDownCapture={handleKeyPressed}
          disableEnforceFocus
          open={openModal}>
          <Paper className={classes.paper} elevation={3}>
            <p className={classes.title}>Are you sure?</p>
            <p className={classes.text}>
              Deleting your key will result in your inability to operations using the EasyIdentity REST APIs. Once the
              key is deleted, it cannot be recovered. You can however generate a new key and use it with the REST APIs
              anytime.
            </p>
            <Grid className={classes.marginTop} container justify='space-between'>
              <Button className={classes.actionBtn} variant='contained' color='primary' onClick={handelAction}>
                Yes
              </Button>
              <Button className={classes.cancelButton} onClick={handleClose}>
                No
              </Button>
            </Grid>
          </Paper>
        </Modal>
      </>
    );
  }
);
export default UserKeyDelete;
